import { configureStore } from "@reduxjs/toolkit";
import analyticsReducer from "~/state/analytics";
import companiesReducer from "~/state/companies";
import enumsReducer from "~/state/enums";
import usersReducer from "~/state/users";
import { getEnums } from "./enums";

const store = configureStore({
  reducer: {
    analytics: analyticsReducer,
    companies: companiesReducer,
    enums: enumsReducer,
    users: usersReducer,
  },
});

store.dispatch(getEnums()).catch(() => {
  // Backend may be offline in local development; keep app booting.
});

export default store;
